import { apiClient, ApiResponse } from './client'

export interface LoginRequest {
  email: string
  password: string
}

export interface RegisterRequest {
  email: string
  password: string
  fullName: string
}

export interface AuthUser {
  id: number
  email: string
  fullName: string
  role?: string
  passwordChangedAt?: string | null
  phoneNumber?: string | null
  countryCode?: string | null
  isPhoneVerified?: boolean
}

export interface AuthResponse {
  user: AuthUser
  accessToken: string
  refreshToken: string
  requiresSetup?: boolean
  setupSteps?: string[]
}

// Account Recovery
export interface FindAccountRequest {
  name: string
  phoneNumber: string
}

export interface FindAccountResponse {
  maskedEmail: string
}

export interface PasswordResetVerifyResponse {
  resetToken: string
}

export const accountRecoveryApi = {
  findAccount: (data: FindAccountRequest) =>
    apiClient.post<ApiResponse<FindAccountResponse>>('/auth/find-account', data),

  requestPasswordReset: (email: string) =>
    apiClient.post<ApiResponse<void>>('/auth/password-reset/request', { email }),

  verifyCode: (email: string, code: string) =>
    apiClient.post<ApiResponse<PasswordResetVerifyResponse>>('/auth/password-reset/verify', { email, code }),

  resetPassword: (resetToken: string, newPassword: string) =>
    apiClient.post<ApiResponse<void>>('/auth/password-reset/confirm', { resetToken, newPassword }),
}

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<ApiResponse<AuthResponse>>('/auth/login', data),

  register: (data: RegisterRequest) =>
    apiClient.post<ApiResponse<AuthUser>>('/auth/register', data),

  logout: () =>
    apiClient.post<ApiResponse<void>>('/auth/logout'),

  me: () =>
    apiClient.get<ApiResponse<AuthUser>>('/auth/me'),

  refresh: (refreshToken: string) =>
    apiClient.post<ApiResponse<AuthResponse>>('/auth/refresh', { refreshToken }),

  setupPassword: (newPassword: string) =>
    apiClient.put<ApiResponse<{ message: string }>>('/auth/setup/password', { newPassword }),

  changePassword: (currentPassword: string, newPassword: string) =>
    apiClient.put<ApiResponse<{ message: string }>>('/auth/password', { currentPassword, newPassword }),
}

